import { render, staticRenderFns } from "./SuZhouEdit.vue?vue&type=template&id=81374ac4&"
import script from "./SuZhouEdit.vue?vue&type=script&lang=js&"
export * from "./SuZhouEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports